import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useTranslations } from "next-intl";
import { HostLegacy } from "@silvertours/front-legacy-entities";
import { UiLegacy } from "@silvertours/front-legacy-shared";
import { Container } from "./Referral.styles";
import { ReferralImageBox } from "./ReferralImageBox";
export var Referral = function() {
    var t = useTranslations("features.referralsLegacy.referrals");
    var formatImage = HostLegacy.useHost().formatImage;
    var camper = {
        title: t("items.camper.title"),
        href: t("items.camper.href"),
        imageSource: formatImage("/bm/global/graphic/image/flexsite/Camper_AdobeStock_294851778.jpg"),
        imageFallback: t("items.camper.imageFallback")
    };
    var transporter = {
        title: t("items.transporter.title"),
        href: t("items.transporter.href"),
        imageSource: formatImage("/bm/global/graphic/image/flexsite/Transporter_AdobeStock_242368361.jpg"),
        imageFallback: t("items.transporter.imageFallback")
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(UiLegacy.SectionTitle, {
                children: t("title")
            }),
            /*#__PURE__*/ _jsxs(Container, {
                children: [
                    /*#__PURE__*/ _jsx(ReferralImageBox, _object_spread({}, camper)),
                    /*#__PURE__*/ _jsx(ReferralImageBox, _object_spread({}, transporter))
                ]
            })
        ]
    });
};
